import styled from "@emotion/styled"
import { spacingStaticMd } from "@porsche-design-system/components-react/emotion"
import { Skeleton } from "src/components"

export const AddCustomEquipmentSkeleton = () => (
	<Wrapper>
		<Skeleton.Input withLabel />
		<Skeleton.Input withLabel />
		<Skeleton.Input withLabel />
	</Wrapper>
)

const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: ${spacingStaticMd}
`
